import { debounce, isEqual } from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';

export const useDebounceV2 = <T = unknown>(value: T, delay: number = 400, enabled: boolean = true) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const debouncedFn = useRef(debounce((newValue: T) => setDebouncedValue(newValue), delay));

  const isDebouncing = useMemo(() => enabled && !isEqual(value, debouncedValue), [value, debouncedValue, enabled]);

  useEffect(() => {
    if (!enabled) return undefined;

    debouncedFn.current(value);

    return () => {
      debouncedFn.current.cancel();
    };
  }, [value, enabled]);

  return { debouncedValue, isDebouncing };
};
